require("cloze/passage_tile.scss");

var PassageTile = ({ title, categoryName, subCategoryName, getIcon, onClick }) => {
	title = decodeHtml(title || "Welcome!");
	
	if (title.indexOf("--Part") != -1) {
		var titleParts = title.split("--Part");
		if (titleParts.length == 2) {
			title = titleParts[0] + " (Part " + titleParts[1].trim() + ")";
		}
	}

	if (subCategoryName) {
		var subCategoryDisplay = (
			<div className="subCategory">{ subCategoryName }</div>
		)
	}
	if (categoryName) {
		if (getIcon) {
			var icon = (
				<img src={ getIcon(categoryName) } className="icon" />
			);
		}

		var categoryDisplay = (
			<div className="category">{ icon }{ categoryName }</div>
		)
	}

	return (
		<div className="Cloze-PassageTile" onClick={ onClick }>
			<div className="title">{ title }</div>
			{ subCategoryDisplay }
			{ categoryDisplay }
		</div>
	);
}

function decodeHtml(content) {
	// Thanks @ Rob W
	// https://stackoverflow.com/a/7394787/4557470
	var textarea = document.createElement("textarea");
	textarea.innerHTML = content;

	return textarea.value;
}


PassageTile.propTypes = {
	title: PropTypes.string,
	categoryName: PropTypes.string,
	subCategoryName: PropTypes.string,
	getIcon: PropTypes.func,
	onClick: PropTypes.func
}


module.exports = PassageTile


// WEBPACK FOOTER //
// ./modules/components/cloze/PassageTile.js